export default [{
    path: '/caderno-servicos',
    component: () => import('@/views/Index'),
    children: [
      {
        name: 'Caderno Servicos Histórico',
        path: 'historico',
        component: () => import('@/views/cadernoServicos/Historico.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups'},
            { name: 'Caderno Servicos' }
          ]
        },
      },
      {
        name: 'Caderno Servicos Adicionar',
        path: 'edit',
        component: () => import('@/views/cadernoServicos/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups'},
            { name: 'Caderno Servicos', path: '/caderno-servicos/historico' },
            { name: 'Adicionar' }
          ]
        },
      }
    ]
  }]